import React, { useState, useCallback, useEffect } from 'react';
import { Button, OutlinedInput, Grid, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { showDialogWin } from '../../slices/customQueryHeaderSlice';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { pushSavedQueryData, pushSavedQueryName, pushSavedQueryDescription, pushInitialDocumentName } from '../../slices/QueriesManagerSlice';
import CloseIcon from '@material-ui/icons/Close';
const initialValues = {
  queryname: 'Untitled',
  description: ''
};
const DialogButton = withStyles({
  root: {
    height: '32px',
    width: '80px',
    borderRadius: '4px',
    backgroundColor: '#1661A6',
    textTransform: 'none'
  },
  label: {
    border: 'none',
    fontSize: 13,
    color: '#FFFFFF',
    fontFamily: '"OpenSans-Regular" !important',
    fontWeight: 500
  }
})(Button);
export const DialogModalTitle = styled(DialogTitle)`
  && {
    color: #3e3e3c !important;
    font-family: 'OpenSans-Regular' !important;
    padding: 16px 22px 8px 22px !important;
    font-weight: 500 !important;
    letter-spacing: 0 !important;
    line-height: 18px !important;
    h3 {
      font-size: 10px !important;
      display: inline;
    }
  }
`;
const OutlinedInputField = withStyles({
  input: {
    padding: '10.5px 14px',
    fontSize: '13px',
    color: '#292928',
    fontFamily: 'OpenSans-Regular !important',
    border: '1px solid #C9D3DC',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    width: '372px'
  },
  multiline: {
    padding: '0px'
  }
})(OutlinedInput);
const useStyles = makeStyles(() => ({
  form: {
    width: '100%'
  }
}));
const ValidationMessage = styled(Typography)`
  font-size: 10px !important;
  color: #cc0000 !important;
  font-family: 'OpenSans-Regular !important';
`;
const SubTextHeader = styled(Typography)`
  color: #9d9797de;
  font-family: 'OpenSans-Regular !important';
  font-size: 12px !important;
  margin-bottom: 6px !important;
`;
const StyledCancleButton = styled(Button)`
  && {
    box-sizing: border-box;
    height: 32px;
    width: 80px;
    border: 1px solid #005099;
    border-radius: 4px;
    background-color: #ffffff;
    text-transform: none;
  }
`;
const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 0px 24px 8px 24px;
  }
`;
const StyledImgDiv = styled.div`
  && {
    float: right;
    margin-right: 40px;
    margin-top: 20px;
    cursor: pointer;
  }
`;
const TitleGrid = styled(Grid)`
  && {
    margin-top: 10px;
  }
`;

const DialogModal = props => {
  const {
    handleSave,
    queryData,
    buttonName,
    changeButtonName
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [formValues, setFormValues] = useState(initialValues);
  const [isValid, setValidateForm] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const showDialogWindow = useSelector(state => state.customQueryHeader.showDialogWin);
  const queryName = useSelector(state => state.queriesManager.queryName);
  const inititalDocumentName = useSelector(state => state.queriesManager.documentName);

  const handleClose = () => {
    let initValues = inititalDocumentName !== 'Untitled' ? { ...initialValues,
      queryname: inititalDocumentName
    } : initialValues;
    const formData = queryName != '' ? {
      queryname: queryData.queryname,
      description: queryData.description
    } : initValues;

    if (inititalDocumentName) {
      changeButtonName('');
    }

    setFormValues(formData);
    setErrorMessage('');
    dispatch(showDialogWin(false));
  };

  useEffect(() => {
    setValidateForm(false);

    if (queryName != '') {
      const editFormValues = {
        queryname: queryData.queryname,
        description: queryData.description
      };
      setFormValues(editFormValues);
    } else {
      setFormValues(initialValues);
    }
  }, []);
  const validateForm = useCallback(() => {
    let {
      queryname
    } = formValues;
    return queryname !== '';
  }, [formValues]);
  useEffect(() => {
    if (!errorMessage) {
      setValidateForm(validateForm());
    }
  }, [formValues, errorMessage]);
  const handleChange = useCallback(event => {
    let {
      name,
      value
    } = event.target;
    let pattern = /^[a-zA-Z0-9~\-_. ]+$/;

    if (value != '' && name == 'queryname') {
      if (pattern.test(value)) {
        setErrorMessage('');
        setValidateForm(true);
        let newValue = {
          [name]: value
        };
        let updatedFormValues = { ...formValues,
          ...newValue
        };
        setFormValues(updatedFormValues);
      } else {
        let newValue = {
          [name]: value
        };
        setFormValues({ ...formValues,
          ...newValue
        });
        setErrorMessage('The name entered is invalid');
        setValidateForm(false);
      }
    } else if (name == 'description') {
      let newValue = {
        [name]: value
      };
      let updatedFormValues = { ...formValues,
        ...newValue
      };
      setFormValues(updatedFormValues);
    } else {
      let newValue = {
        [name]: value
      };
      setFormValues({ ...formValues,
        ...newValue
      });
      setErrorMessage('Field Cannot be empty');
      setValidateForm(false);
    }
  }, [formValues]);
  const onSaveClick = useCallback(() => {
    if (validateForm()) {
      if (queryName != '') {
        const editFormValues = {
          queryname: formValues.queryname,
          description: formValues.description
        };
        setFormValues(editFormValues);
        editFormValues.queryid = queryData.queryid;
        dispatch(pushSavedQueryName(formValues.queryname));
        dispatch(pushSavedQueryDescription(formValues.description));
        dispatch(pushSavedQueryData(editFormValues));

        if (buttonName === 'Save As') {
          handleSave(formValues, buttonName);
        }
      } else if (inititalDocumentName) {
        const editFormValues = {
          queryname: formValues.queryname,
          description: formValues.description
        };
        setFormValues(editFormValues);
        setFormValues(editFormValues);
        dispatch(pushInitialDocumentName(formValues.queryname));

        if (buttonName === 'Save') {
          handleSave(formValues, buttonName);
        }
      } else {
        handleSave(formValues, buttonName);
        setFormValues(initialValues);
      }

      dispatch(showDialogWin(false));
    }
  }, [formValues, buttonName]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    open: showDialogWindow,
    onClose: handleClose,
    "aria-labelledby": "form-dialog-title",
    fullWidth: true,
    maxWidth: "xs"
  }, /*#__PURE__*/React.createElement(TitleGrid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    sm: 8
  }, /*#__PURE__*/React.createElement(DialogModalTitle, {
    id: "form-dialog-title"
  }, queryName && buttonName !== 'Save As' || inititalDocumentName && buttonName == '' ? 'Edit Query Information' : 'Save Query')), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 4
  }, /*#__PURE__*/React.createElement(StyledImgDiv, {
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React.createElement(StyledDialogContent, null, /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement("label", {
    className: "query-lbl-name"
  }, "Query Name"), /*#__PURE__*/React.createElement(SubTextHeader, {
    paragraph: true
  }, "Query Name should only contain (a-z,A-Z,0-9 , -, _)"), /*#__PURE__*/React.createElement(OutlinedInputField, {
    onChange: handleChange,
    name: "queryname",
    fullWidth: true,
    required: true,
    id: "queryname",
    defaultValue: queryData.queryname,
    value: formValues.queryname
  }), errorMessage || !isValid ? /*#__PURE__*/React.createElement(ValidationMessage, {
    paragraph: true,
    style: {
      color: '#fefefef'
    }
  }, errorMessage) : ''), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    className: "m-t-1"
  }, /*#__PURE__*/React.createElement("label", {
    className: "query-lbl-name"
  }, "Description"), /*#__PURE__*/React.createElement(OutlinedInputField, {
    onChange: handleChange,
    name: "description",
    fullWidth: true,
    required: true,
    id: "description",
    multiline: true,
    rowsMax: 5,
    rows: 3,
    defaultValue: queryData.description,
    value: formValues.description
  }))))), /*#__PURE__*/React.createElement(DialogActions, {
    style: {
      padding: '8px 24px 16px 24px'
    }
  }, /*#__PURE__*/React.createElement(StyledCancleButton, {
    variant: "outlined",
    color: "primary",
    onClick: handleClose
  }, "Cancel"), /*#__PURE__*/React.createElement(DialogButton, {
    variant: "contained",
    color: "primary",
    disabled: !isValid,
    onClick: onSaveClick,
    style: {}
  }, "OK"))));
};

export default /*#__PURE__*/React.memo(DialogModal);